import React from "react";
import { Main } from "../../../components/utilities";

export * from "./AssetManagementMicroserviceManagementPage";
export * from "./AuditLogsMicroserviceManagementPage";
export * from "./CampaignManagementMicroserviceManagementPage";
export * from "./ClientAuthMicroserviceManagementPage";
export * from "./ClientDetailsMicroserviceManagementPage";
export * from "./ClientFactFindMicroserviceManagementPage";
export * from "./ClientProjectsMicroserviceManagementPage";
export * from "./ClientProjectSummaryMicroserviceManagementPage";
export * from "./ClientReportsMicroserviceManagementPage";
export * from "./ClientReviewsMicroserviceManagementPage";
export * from "./ClientSearchMicroserviceManagementPage";
export * from "./GraphMicroserviceManagementPage";
export * from "./HeadOfficeAdminMicroserviceManagementPage";
export * from "./IdentityMicroserviceManagementPage";
export * from "./MessagingMicroserviceManagementPage";
export * from "./NavigationMicroserviceManagementPage";
export * from "./ProductsMicroserviceManagementPage";
export * from "./RecommendationsMicroserviceManagementPage";
export * from "./RemindersMicroserviceManagementPage";
export * from "./ValuationsMicroserviceManagementPage";

export const MicroserviceManagementPage = () => (
    <Main className="d-flex flex-column">
        <section className="px-4 my-3 h-100">
            <h1>Microservice Management</h1>
            <p>Here you can manage and seed individual microservices</p>
        </section>
    </Main>
);